import React, { useEffect } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import Navbar from './Navbar';
import HeroSection from './HeroSection';
import SelectedWorksSection from './SelectedWorksSection';
import HomeAboutTeaser from './HomeAboutTeaser';
import ServicesSection from './ServicesSection';
import ProcessSection from './ProcessSection';
import TestimonialsSection from './TestimonialsSection';
import ContactSection from './ContactSection';
import Transition from './Transition';
import SEO from './SEO';

const HOMEPAGE_DESCRIPTION =
  'Sander Kuyken — Belgian graphic designer specialised in branding, motion graphics, 3D / VFX and web/UX design. 4+ years of professional work across gaming, tech, retail, real estate and beauty. Browse selected works and get in touch.';

const HOMEPAGE_JSONLD = {
  '@context': 'https://schema.org',
  '@type': 'Person',
  name: 'Sander Kuyken',
  alternateName: 'SK Design',
  jobTitle: 'Graphic Designer',
  url: 'https://portfolio.skdesign.be/',
  email: 'mailto:info@skdesign.be',
  sameAs: [
    'https://www.linkedin.com/in/sander-kuyken-8a384716b/',
    'https://www.artstation.com/kuyken',
    'https://skdesign.be/',
  ],
  knowsAbout: ['Graphic Design', 'Motion Graphics', '3D', 'VFX', 'Branding', 'Web Design'],
  description: HOMEPAGE_DESCRIPTION,
};

gsap.registerPlugin(ScrollTrigger);

const HomePage = () => {
  useEffect(() => {
    // Initialize scroll reveal animations
    const scrollElements = document.querySelectorAll('.scroll-reveal');

    scrollElements.forEach((element) => {
      gsap.fromTo(element,
        {
          opacity: 0,
          y: 50
        },
        {
          opacity: 1,
          y: 0,
          duration: 0.8,
          ease: "power3.out",
          scrollTrigger: {
            trigger: element,
            start: "top 80%",
            end: "bottom 20%",
            toggleActions: "play none none reverse"
          }
        }
      );
    });

    // Smooth scroll behavior
    const links = document.querySelectorAll('a[href^="#"]');
    links.forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const targetId = link.getAttribute('href').substring(1);
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
          targetElement.scrollIntoView({ behavior: 'smooth' });
        }
      });
    });

    return () => {
      ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    };
  }, []);

  return (
    <main>
      <SEO
        title="Graphic Designer Portfolio"
        description={HOMEPAGE_DESCRIPTION}
        path="/"
        jsonLd={HOMEPAGE_JSONLD}
      />
      <Navbar />
      <section id="hero">
        <HeroSection />
      </section>

      <section id="works">
        <SelectedWorksSection />
      </section>

      {/* About teaser (Fase 2) */}
      <section id="about-teaser">
        <HomeAboutTeaser />
      </section>

      <section id="services">
        <ServicesSection />
      </section>

      {/* Process (Fase 2) */}
      <section id="process">
        <ProcessSection />
      </section>

      {/* Client proof (Fase 6) — now backed by realistic, project-based,
          attributable testimonials in data/testimonials.js. */}
      <section id="testimonials">
        <TestimonialsSection />
      </section>

      <section id="contact">
        <ContactSection />
      </section>
    </main>
  );
};

export default Transition(HomePage);


